import Plugin from '@ckeditor/ckeditor5-core/src/plugin'
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview'

import fileIcon from './assets/UploadFile.svg' // Uses an existing CKEditor icon

export default class CustomFileExplorerPlugin extends Plugin {
  init() {
    const editor = this.editor

    editor.ui.componentFactory.add('insertFileExplorer', (locale) => {
      const button = new ButtonView(locale)

      button.set({
        label: 'File Explorer',
        icon: fileIcon,
        tooltip: true,
      })

      // When button is clicked, trigger function
      button.on('execute', () => {
        if (editor.config.get('openFileExplorer')) {
          editor.config.get('openFileExplorer')()
        }
      })

      return button
    })
  }
}
